





































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";

class jobs {
    job_id!:number;
    task!:string;
    status!:number;
    message!:string;
    created_at!:string;
    updated_at!:string;
    zip_url:string = "";
}
@Component({
    components: {
        DeleteButton,EForm,Number,TextField,Id
    }
})
export default class Jobs extends  Vue{
    items : jobs[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "jobs";
    action:string = this.baseAction;
    data : jobs = new jobs();
    jobInterval:any;
    taskItems : any[] = [
        {
            value:"ImagesTask",
            text:"Siparis resimleri zip"
        },
        {
            value:"OrderBarcodeTask",
            text:"Kargo barkod olustur (Sipariş hazirlanıyora çeker)"
        },
        {
            value:"CargoStatusUpdateTask",
            text:"Kargo check (Hazırlanıyor ve Kargolananları sorgular)"
        },
        {
            value:"MailTask",
            text:"Queue Mail Test"
        }
    ];
    statusArray:any[]=[
        {
            value:0,
            text:"Bekliyor",
            color:"info",
        },
        {
            value:1,
            text:"Çalışıyor",
            color:"warning",
        },
        {
            value:2,
            text:"Hata",
            color:"red",
        },
        {
            value:3,
            text:"Tamamlandı",
            color:"success",
        }
    ];
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "job_id"
        },
        {text: "İş", value: "task"},
        {text: "Durum", value: "status"},
        {text: "Oluşturulma Tarihi", value: "created_at"},
        {text: "İşlem Tarihi", value: "updated_at"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:jobs){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.job_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new jobs();
        this.dialog = true;
    }
    async reload(){
        this.dialog = false;
        this.get();
    }
    async get(){
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    destroyed() {
        //console.log("Destroyed compenent");
        clearInterval(this.jobInterval);
    }
    created(){
        this.get();
        this.jobInterval = setInterval(()=>{
            this.get();
        },1000)
    }
};
